import { validateTimeInput } from "../../../../utils";

export const handleTimeInputChange = (
  value: string,
  setValue: (val: string) => void,
  setIsError: (isError: boolean) => void,
  setErrorText: (errorText: string | undefined) => void
) => {
  setValue(value);
  const { isValid, errorMsg } = validateTimeInput(value);
  setIsError(!isValid);
  setErrorText(isValid ? undefined : errorMsg);
};
